/**
 * Default legend configurations for charts
 */

export const DEFAULT_LEGEND = {
  visible: true,
  orient: 'bottom',
  position: 'middle',
  padding: [8, 0, 8, 0],
  itemGap: 12,
  itemMarker: {
    symbol: 'square',
    size: 10
  },
  title: {
    visible: false
  },
  item: {
    style: {
      fontSize: 12
    },
    state: {
      hover: {
        opacity: 0.7
      }
    },
    name: (datum) => {
      // Try to use the name field (set in BaseChart.getMeaningfulItemName)
      if (datum && datum.name) {
        return datum.name;
      }
      // If no name, try common name fields
      for (const field of ['label', 'title', 'displayName', 'category']) {
        if (datum && datum[field]) {
          return datum[field];
        }
      }
      // If still no name, return as is
      return datum;
    }
  },
  pager: {
    visible: true
  }
};

// Legend position variations
export const LEGEND_POSITIONS = {
  TOP: {
    orient: 'top',
    position: 'middle'
  },
  BOTTOM: {
    orient: 'bottom',
    position: 'middle'
  },
  LEFT: {
    orient: 'left',
    position: 'middle'
  },
  RIGHT: {
    orient: 'right',
    position: 'middle'
  },
  TOP_LEFT: {
    orient: 'top',
    position: 'start'
  },
  TOP_RIGHT: {
    orient: 'top',
    position: 'end'
  },
  BOTTOM_LEFT: {
    orient: 'bottom',
    position: 'start'
  },
  BOTTOM_RIGHT: {
    orient: 'bottom',
    position: 'end'
  }
}; 